/**
 * Splits agent prose on `[Record Title](rec:rN)` citation links into text and
 * chip segments, and strips bare `rec:rN` leftovers.
 */

export type AgentTextSegment =
    | { kind: "text"; text: string }
    | { kind: "chip"; label: string; handle: string };

/** Bounded so a malformed or adversarial response cannot drive catastrophic backtracking. */
const REC_LINK_RE = /\[([^\]\n]{1,200})\]\(rec:(r\d{1,4})\)/g;
const BARE_HANDLE_RE = /\(?\brec:r\d{1,4}\b\)?/g;

export function parseRecLinks(text: string): AgentTextSegment[] {
    const segments: AgentTextSegment[] = [];
    let last = 0;

    for (const match of text.matchAll(REC_LINK_RE)) {
        const index = match.index ?? 0;
        if (index > last) {
            segments.push({ kind: "text", text: text.slice(last, index) });
        }
        segments.push({ kind: "chip", label: match[1], handle: match[2] });
        last = index + match[0].length;
    }

    if (last < text.length) {
        segments.push({ kind: "text", text: text.slice(last) });
    }

    return segments
        .map((segment) =>
            segment.kind === "text"
                ? { ...segment, text: segment.text.replace(BARE_HANDLE_RE, "") }
                : segment,
        )
        .filter((segment) => segment.kind === "chip" || segment.text.length > 0);
}
